function FaturaAdmin() {
return <div>Fatura Admin</div>
}

export default FaturaAdmin;